@if (config.type !== BadgeType.Dot) {
  <ng-content />
}
